import { createSlice } from '@reduxjs/toolkit';

// Slice
export const userActivitySlice = createSlice({
  initialState: {
    userActivity: { logType: '', createdAt: undefined },
  },
  name: 'userActivity',
  reducers: {
    setUserActivity: (state, action) => {
      state.userActivity = { logType: action.payload, createdAt: new Date() };
    },
  },
});

// Reducer
export const userActivityReducer = userActivitySlice.reducer;

// Actions
export const { setUserActivity } = userActivitySlice.actions;

// Selectors
export const selectUserActivityResult = (state) => state.userActivityReducer.userActivity;
